import { MetricCardStatus } from "../components/DashboardItems/MertricCardElement";
import { useState } from "react";

export const transformIconColor = (metricCardStatus: MetricCardStatus) => {
    if (metricCardStatus.status === 'success') {
        return 'primary'
    }
    if (metricCardStatus.status === 'error') {
        return 'danger'
    }
    return metricCardStatus.status
}

export const useMetricStatus = (): [MetricCardStatus, any] => {
    const [metricStatus, setMetricStatus] = useState<MetricCardStatus>({
        status: 'success',
        message: `All data are fine`,
    })
    return [metricStatus, setMetricStatus]
}
